import React, { Component } from 'react';
import { Spin, Select } from 'antd';
import $ from '../../common/AjaxRequest';

const { Option } = Select;

class SearchMulRetrieve extends Component {
    constructor(props) {
        super(props);
        this.search = false;
        this.state = {
            data: [],
            fetching: false,
            selectKey: Date.now(),
        };
    }

    componentDidMount() {
        const { shouldSearch, value } = this.props;
        if (shouldSearch && value && !this.search) {
            this.search = true;
            this.queryData();
        }
    }

    handleFocus = () => {
        this.queryData();
    }

    handleSelect = (value) => {
        const { data } = this.state;
        const option = data.find(i => i.value == value) || {};
        this.props.onChange(value, option);
    }

    onChange = ( value ) => {
        if( !value.length ) this.props.onChange(value);
    }

    handleDeSelect = (value) => {
        this.props.onChange(value);
    }

    handleSearch = (search) => {
        this.queryData(search);
    }

    //解决点击别处下拉框数据不显示问题
    handleBlur = () => {
        this.setState({ selectKey: Date.now() });
    };

    queryData = (text) => {
        const { url, params, keyword, config } = this.props;
        const { id, name, code, type, show } = config;

        let label = text;
        if (label) {
            if (show === 'user') {
                const index = label.indexOf('[');
                if (index && label.endsWith(']')) {
                    label = label.slice(0, index);
                }
            } else if (show === 'site') {
                const index = label.indexOf('-(');
                if (index && label.endsWith(')')) {
                    label = label.slice(0, index);
                }
            }
        }

        this.setState({ fetching: true });
        const options = {
            method: 'POST',
            url,
            data: {
                ...params,
                [keyword]: label,
            },
            dataType: 'json',
            doneResult: res => {
                let data;
                if ((res.data || res.datas || res.list || res.doctors || res.employeeList || res.investigationSiteList)) {
                    let sourceData;
                    if (type === 'projectName') {
                        sourceData = res.data.enterpriseWorkCategories;
                    } else if (type === 'site') {
                        sourceData = res.data.siteList.datas;
                    } else if (type == 'hospital') {
                        sourceData = res.data.hospitalList.datas;
                    } else if (type == 'researcher') {
                        sourceData = res.doctors;
                    } else if (type == 'investigationSite') {
                        sourceData = res.investigationSiteList;
                    } else if (type == 'workTypes') {
                        sourceData = res.data.enterpriseWorkTypes;
                    } else {
                        sourceData = res.data || res.datas || res.list || res.employeeList || [];
                    }
                    data = (sourceData || []).map(item => {
                        const param = {
                            ...item,
                            value: item[id],
                            text: item[name],
                        };
                        if (show === 'user') {
                            param.text = `${item[name]}[${item[code]}]`;
                        } else if (show === 'site') {
                            param.text = `${item[name]}-(${item[code]})`;
                        } else if (show === 'workTypes') {
                            param.text = `${item[name]}(${item[code]})`;
                        } else if (show === 'parentheses') {
                            param.text = `${item[name]}(${item[code]})`;
                        }
                        return param;
                    });
                } else {
                    data = [];
                }

                this.setState({
                    data,
                    fetching: false,
                });
            }
        };
        $.sendRequest(options);
    }

    render() {
        const { data, fetching, selectKey } = this.state;
        const { value, style, disabled, placeholder } = this.props;
        const dataSource = (data || []).map(i =>
            <Option key={i.value}>
                {i.text}
            </Option>
        );
        return (
            <Select
                showSearch
                key={selectKey}
                style={style}
                mode="multiple"
                disabled={disabled}
                onFocus={this.handleFocus}
                onSearch={this.handleSearch}
                onSelect={this.handleSelect}
                onChange={this.onChange}
                onDeselect={this.handleDeSelect}
                onBlur={this.handleBlur} 
                defaultActiveFirstOption={false}
                notFoundContent={fetching ? <Spin size="small" /> : '无匹配结果'}
                placeholder={placeholder}
                filterOption={false}
                allowClear={true}
                value={value}
            >
                {dataSource}
            </Select>
        );
    }
}

export default SearchMulRetrieve;


// WEBPACK FOOTER //
// ./src/components/common/SearchMulRetrieve.js